<template>
  <div class="avatar__container">
    <label for="file">
      <img
        v-if="!image"
        src="@/assets/images/portrait/small/avatars1.png"
        alt="user-img"
        width="100"
        height="100"
        class="rounded-full shadow-md cursor-pointer block"
      />
      <img
        v-else
        :src="src"
        alt="user-img"
        width="100"
        height="100"
        class="rounded-full shadow-md cursor-pointer block"
      />
      <feather-icon
        class="avatar__icon"
        icon="CameraIcon"
        svgClasses="text-white stroke-current"
      />
    </label>
    <input
      id="file"
      ref="file"
      type="file"
      :accept="accept"
      v-on:change="handleChange"
    />
  </div>
</template>

<script>
export default {
  name: "avatar-input",
  props: {
    src: {
      type: String
    },
    accept: {
      type: String,
      default: ".jpg,.jpeg,.png"
    }
  },
  computed: {
    image() {
      return this.src;
    }
  },
  methods: {
    handleChange(el) {
      this.$emit("onChange", el.target.files[0]);
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar__container {
  width: 100px;
  height: 100px;
}

.avatar__container > label {
  position: relative;

  img {
    object-fit: cover;
  }

  span {
    border-radius: 25px;
    background: rgba($color: #000000, $alpha: 0.7);
    padding: 5px;
    position: absolute !important;
    right: -100px;
    bottom: 18px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
}

.avatar__container > input[type="file"] {
  width: 100px;
  height: 100px;
  opacity: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
}
</style>
